import React, { useEffect } from "react";
import Infiry from "../About/Infiry";
import Callin from "../About/Callin";
import Divser from "../About/Divser";
import ServiceReview from "../Services/ServiceReview";
import Doctorcon from "./Doctorcon";
import { movetop } from "../../fun";
import { Helmet } from "react-helmet-async";
import Aboutbanner from "../About/Aboutbanner";
import Infobox from "../About/Infobox";

function Doctor() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Doctorcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Doctors in Whitefield</title>
        <meta
          name="description"
          content="Looking for the Best doctors in Whitefield or Vijayanagar? Then you are in the right place. Contact us today."
        />
        <meta
          name="keywords"
          content="Best Doctors in Whitefield, Best Doctors in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id": "https://www.elvhealthcare.com/bestdoctor#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestdoctor",
            description:
              "ELV Health Care Polyclinics in Whitefield, Bangalore provides access to experienced doctors across multiple specialties, offering consultations, diagnosis, treatment planning, follow-ups, and coordinated care under one roof.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: ["+91-9535264855", "+91-9535264854"],
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Multi-specialty doctor consultations",
              "General physician and primary care",
              "Pediatrics and child health consultations",
              "Orthopedics and joint pain evaluation",
              "Cardiology consultation and cardiac screening",
              "Dermatology consultation and skin care",
              "ENT consultation and treatment",
              "OBG consultation and women’s health care",
              "Neurology consultation and evaluation",
              "Diabetes care and chronic disease management",
              "Preventive health screening and follow-up care",
            ],
            keywords: [
              "Best Doctors in Immadihalli",
              "Best Doctors in Whitefield",
              "Best Doctors in Bangalore",
              "Best Doctors in Kundalahalli",
              "Best Doctors in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <Aboutbanner name="Doctor" banner={"../photo/sam1.jpg"} />
      <div style={{ backgroundColor: "#eff6ff" }} className="pb-2">
        <Infobox />
      </div>
      <div className="pt-0 pb-6"></div>
      <Divser elemnt={elemnt} />
      <ServiceReview />
    </>
  );
}

export default Doctor;
